import {
  MessageScroller,
  MessageScrollerButton,
  MessageScrollerContent,
  MessageScrollerItem,
  MessageScrollerProvider,
  MessageScrollerViewport
} from 'design-system';

import { useChatState } from '../../../state/useChat';
import MessageComponent from '../Messages/MessageComponent';
import NoMessagesScreen from '../NoMessagesScreen/NoMessagesScreen';

// `hideEmptyState` skips the generic NoMessagesScreen (with its own default
// sample prompts) when a `SignalContextBanner` above already offers prompts,
// so the two don't show conflicting suggestions at once.
const Chat = ({ hideEmptyState = false }: { hideEmptyState?: boolean }) => {
  const { conversationId, messages } = useChatState();

  if (messages.length === 0) return hideEmptyState ? null : <NoMessagesScreen />;

  return (
    <MessageScrollerProvider
      autoScroll
      key={conversationId}
      defaultScrollPosition='last-anchor'
    >
      <MessageScroller className='flex-1 bg-[#0a0a0f]'>
        <MessageScrollerViewport>
          <MessageScrollerContent className='mx-auto w-full gap-3 px-4 py-4'>
            {messages.map((msg, index) => (
              <MessageScrollerItem
                key={msg.id}
                messageId={msg.id}
                scrollAnchor={msg.role === 'user'}
              >
                <MessageComponent
                  index={index}
                  msg={msg}
                />
              </MessageScrollerItem>
            ))}
          </MessageScrollerContent>
        </MessageScrollerViewport>
        <MessageScrollerButton className='border-gx-border bg-gx-tile-dark shadow-lg hover:bg-gx-response' />
      </MessageScroller>
    </MessageScrollerProvider>
  );
};

export default Chat;
